module.exports = __webpack_public_path__ + "src/assets/img/6_2art_2part.48953142.jpg";